import React from "react";
import DateTimeText from "../../ui/DateTimeText";
import { Transaction } from "../../../types/modules/transaction.type";
import { StoreTransactionType } from "../../../types/enum/transactionStatus";
import PriceText from "../../ui/PriceText";
import { formatNumber } from "../../../utils/formatNumber";
import { useTranslation } from "react-i18next";

type Props = {
  transactions: Transaction[];
};

const TransactionsTable: React.FC<Props> = ({ transactions }) => {
  const { t } = useTranslation();

  console.log(transactions)

  const statusClasses: Record<StoreTransactionType, string> = {
    COMPLETED: "bg-primaryButton text-white",
    SETTLEMENT: "bg-Cyne text-white",
    REFUND: "bg-Red text-white",
    CANCELED: "bg-DarkGrey3 text-white",
    ADMIN_WITHDRAW: "bg-Red text-white", // 🔴 Withdraw action
  };

  const amountColors: Record<StoreTransactionType, string> = {
    COMPLETED: "text-primaryButton",
    SETTLEMENT: "text-Black",
    REFUND: "text-Red",
    CANCELED: "text-DarkGrey2",
    ADMIN_WITHDRAW: "text-Red", // 🔴 Matches danger color
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal">{t("order_no_customer")}</th>
            <th className="p-3 font-normal">{t("dateTime")}</th>
            <th className="p-3 font-normal">{t("status")}</th>
            <th className="p-3 font-normal">{t("order_amount")}</th>
            <th className="p-3 font-normal">{t("commission_percent")}</th>
            <th className="p-3 font-normal">{t("commission_amount")}</th>
            <th className="p-3 font-normal">{t("store_revenue")}</th>
          </tr>
        </thead>

        <tbody className="text-sm">
          {transactions.map((tx) => (
            <tr
              key={tx.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
              {/* Order / Customer */}
              <td className="p-3 flex items-center gap-3 min-w-[250px]">
                {(tx.status === StoreTransactionType.SETTLEMENT || tx.status===StoreTransactionType.ADMINWITHDRAW) ? (
                  <img
                    src="/logo.png"
                    alt="Website"
                    className="w-[180px] h-14 "
                  />
                ) : (
                  <>
                    <img
                      src={
                        tx.order?.customer.imageUrl ??
                        tx.order?.customer.avatar?.url ??
                        ""
                      }
                      alt={tx.order?.customer.name}
                      className="w-14 h-14 rounded-full object-cover"
                    />
                    <div className="flex flex-col">
                      <span className="text-Black mb-1 font-black text-[12px]">
                        {tx.order?.customer.name}
                      </span>
                      <span className="text-DarkGrey3 font-semibold text-[12px]">
                        #{formatNumber(tx.order?.orderNumber ?? 0)}
                      </span>
                    </div>
                  </>
                )}
              </td>

              {/* Date */}
              <td className="p-3 min-w-[350px] text-DarkGrey2 font-semibold">
                  <DateTimeText date={tx.order?.paidAt || tx.createdAt} />
              </td>

              {/* Status */}
              <td className="p-3 min-w-[200px] capitalize">
                <span
                  className={`px-2 py-2 flex items-center justify-center rounded-tl-[20px] rounded-tr-[8px] rounded-br-[20px] rounded-bl-[8px] w-fit text-xs ${statusClasses[tx.status]}`}
                >
                  {t(tx.status)}
                </span>
              </td>

              {/* Total Amount */}
              <td
                className={`p-3 min-w-[180px] font-black ${amountColors[tx.status]}`}
              >
                <div className="flex items-center gap-1">
                  {/* Choose the image based on transaction status */}
                  <img
                    src={
                      tx.status === StoreTransactionType.COMPLETED
                        ? "/Vector.png"
                        : tx.status === StoreTransactionType.SETTLEMENT ||
                          tx.status === StoreTransactionType.CANCELED
                        ? "/Vector2.png"
                        : "/Vector3.png"
                    }
                    className="w-[10.67px] h-[11.95px]"
                    alt="amount icon"
                  />
                  <>
                    {tx.status === StoreTransactionType.REFUND && <span>- </span>}
                    <PriceText
                      value={tx.totalAmount??0}
                      color={amountColors[tx.status]}
                    />
                  </>
                </div>
              </td>

              {/* Commission Percent */}
              <td className="p-3 min-w-[220px] text-DarkGrey3 font-semibold">
                {tx.commissionPercent
                  ? `${tx.commissionPercent}%`
                  : <span className=" text-DarkGrey3">----</span>}
              </td>

              {/* Commission Amount */}
              <td className="p-3  min-w-[220px] text-DarkGrey3 font-semibold">
                {tx.commissionAmount ? (
                  <div className="flex items-center gap-1">
                    <img src="/Vector2.png" alt="" />
                    <PriceText value={tx.commissionAmount} />
                  </div>
                ) : (
                  <span className=" text-DarkGrey3">----</span>
                )}
              </td>

              {/* Store Revenue */}
              <td className="p-3   min-w-[220px] text-success font-bold">
                {tx.storeRevenue ? (
                  <div className="flex items-center gap-1">
                    <img src="/Vector2.png" alt="" />
                    <PriceText value={tx.storeRevenue} />
                  </div>
                ) : (
                  "----"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionsTable;
